const benefits = [
  {
    icon: 'ri-calendar-event-line',
    title: 'Consultation Booking',
    text: 'Auto-schedule site visits and consultations with qualified solar prospects instantly.',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Financing Follow-Ups',
    text: 'Automated sequences keep financing conversations alive through long approval timelines.',
  },
  {
    icon: 'ri-time-line',
    title: 'Long Cycle Nurturing',
    text: 'Stay top-of-mind for 6-12 month decision journeys with structured drip campaigns.',
  },
];

export default function SolarSection() {
  return (
    <section className="bg-[#0F172A] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="inline-block bg-amber-500 text-slate-900 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-5">
            Solar Companies
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white mb-6">
            Built for Solar Sales Cycles
          </h2>
          <p className="text-slate-400 text-lg leading-relaxed">
            Solar isn&apos;t a quick sale—it&apos;s a multi-month relationship. Omega
            Solutions AI provides automation tailored for consultation booking,
            financing follow-ups, and the unique complexity of long sales
            timelines. Keep every prospect engaged from first touch to final
            signature, without manual effort.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500/20 rounded-xl mb-5">
                <i className={`${benefit.icon} text-amber-400 text-xl`} />
              </div>
              <h3 className="text-white text-xl font-bold mb-3">
                {benefit.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                {benefit.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
